import React, { useContext, useEffect, useState } from "react";
import Faq from "../Dashboard/Faq";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ProjectContext } from "../../ProjectContext";
import axios from "axios";
import { ConnectButton, useConnectModal } from "@rainbow-me/rainbowkit";
import { ethers } from "ethers";

function LoginBox() {
  const { link_ref_address } = useParams();

  const { account, copyaddress, dbuser, toastSuccess, toastError, formatAddress, getuserDB, Refaddress, setRefAddress, settings } = useContext(ProjectContext)

  const [uname, setuname] = useState(null);
  const [m_number, setm_number] = useState(null);
  const [dname, setdname] = useState(null);
  const [email, setemail] = useState(null);
  const [reff_address, setreff_address] = useState(null);
  const [address, setaddress] = useState(null);
  const [tandc, settandc] = useState(false);
  const { openConnectModal } = useConnectModal();

  console.log("dbuser", dbuser);
  var navigate = useNavigate();

  useEffect(() => {
    if (dbuser !== null) {
      navigate("/dashboard");
    }
  }, [dbuser])
  useEffect(() => {
    setaddress(account)
  }, [account])
  useEffect(() => {
    if (dbuser !== null) {
      if (dbuser.referral !== null) {
        // setreff_address(dbuser.user);
      }
    } else {
      setreff_address(link_ref_address);
    }
  }, [link_ref_address, dbuser, account]);
  useEffect(() => {
    // Get the current URL path
    const path = window.location.pathname;

    // Extract the address from the URL (after the last '/')
    const extractedAddress = path.split('/').pop();

    // Store the address in the state
    setRefAddress(extractedAddress);

    // Store the extracted address in localStorage
    localStorage.setItem('referralAddress', extractedAddress);

    console.log('Extracted Address:', extractedAddress);
  }, []);


  const addCustomToken = async () => {
    try {
      // Check if MetaMask is available
      if (typeof window.ethereum !== 'undefined') {

        // Ensure the token address is a valid Ethereum address (BEP20 tokens are also ERC20 tokens on Binance Smart Chain)
        if (!ethers.utils.isAddress(settings?.defin)) {
          toastError('Invalid token address');
          return;
        }


        // Try adding the ERC20/BEP20 token to the wallet
        const tokenAdded = await window.ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20',  // BEP20 tokens are considered ERC20 tokens on BSC
            options: {
              address: settings?.defin,  // Token contract address
              symbol: "DEFIN",    // Token symbol (e.g., 'USDT')
              decimals: 18, // Token decimals (e.g., 18)
            },
          },
        });

        console.log("tokenAdded", tokenAdded);

        // Notify the user whether the token was successfully added
        if (tokenAdded) {
          toastSuccess('Defin Token added successfully!');
        } else {
          toastSuccess('Failed to add Defin Token. Please check the details.');
        }
      } else {
        // If MetaMask is not installed, alert the user
        toastError('MetaMask is not installed. Please install MetaMask to add custom tokens.');
      }
    } catch (error) {
      // Handle any errors during the process
      toastError('An error occurred while adding the defin token.');
      console.error('Error adding custom token:', error);
    }
  };


  const addCustomNetwork = async () => {
    try {
      // Check if MetaMask is available
      if (typeof window.ethereum !== 'undefined') {
        // The network configuration you want to add (Example: Binance Smart Chain)
        const customNetwork = {
          chainId: '0x38', // 0x38 is the chain ID for BSC Mainnet
          chainName: 'Binance Smart Chain',
          rpcUrls: ['https://bsc-dataseed1.binance.org:443'], // RPC URL for BSC
          nativeCurrency: {
            name: 'Binance Coin',
            symbol: 'BNB', // Symbol for the native currency
            decimals: 18,
          },
          blockExplorerUrls: ['https://bscscan.com'], // URL for BSC Block Explorer
        };

        // Add the custom network to MetaMask
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [customNetwork],
        });

        toastSuccess('Binance Smart Chain added successfully!');
      } else {
        toastError('MetaMask is not installed. Please install MetaMask first.');
      }
    } catch (error) {
      console.error('Error adding Binance Smart Chain network:', error);
      toastError('Failed to add Binance Smart Chain network. Please check the console for errors.');
    }
  };


  return (
    <div>
      <div className="content-body pt-0">
        {/* row */}
        <div className="d-flex align-items-center justify-content-center text-start">
          <div>
            {/* Background Video */}
            <video
              autoPlay
              muted
              loop
              className="video-1 w-100 h-100"
              playsInline
            // className="w-100 d-none d-sm-block"
            >
              <source src="assets/img/hero.mp4" type="video/mp4" />
            </video>

            {/* Centered Content */}
            <div className="d-flex justify-content-center mt-5">

              <div>
                <div className="d-flex justify-content-center mb-4">
                  <div className=" text-white text-center rounded shadow-lg box-login-size ">
                    <img src="../assets/img/logo.svg" width="250" alt="" srcset="" />
                    <h2 className="fw-medium my-3 text-white">
                      Welcome to Defin
                    </h2>
                    <p className="fw-medium my-3">
                      Please connect your wallet to continue
                    </p>
                    {account ?
                      <Link
                        type="button"
                        to="/dashboard"
                        className="  text-white  p-3 px-4  btn-outline-bg-new-primary "
                      >
                        Login
                      </Link>

                      :

                      <button
                        type="button"
                        onClick={() => openConnectModal()}
                        className="  text-white  p-3 px-4  btn-outline-bg-new-primary "
                      >
                        Connect Wallet
                      </button>
                      // <ConnectButton />

                    }
                    <div className="d-flex justify-content-between mt-5">
                      <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2" onClick={addCustomToken}>
                        <b className="fs-18">Add Token</b>
                      </span>
                      <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2" onClick={addCustomNetwork}>
                        <b className="fs-18">Add Chain</b>
                      </span>
                    </div>
                  </div>
                </div>
                <Faq />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginBox;